require('./navbarCC.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @components
const Tabs = require('components/commons/tabs/tabs');
const TabLink = require('components/commons/tabs/tabLink/tabLink');
const TabDropdown = require('components/commons/tabs/tabDropdown/tabDropdown');
const TopBarCC = require('components/contactCenter/navbarCC/topBarCC');
const BottomBarCC = require('components/contactCenter/navbarCC/bottomBarCC');

// @ core
const { getLanguage, FormattedText } = require('core/i18n').i18n;

// @ utilities
const { getFullName } = require('utilities/personalDataHelper');
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');
const { getSecurityLevel, securityLevels } = require('utilities/usd');
const storage = require('utilities/storage');

// @ actions
const agentAuthentication = require('actions/contactCenter/agentAuthentication/agentAuthentication');

// @ constants
const nerudaUserConstants = require('constants/nerudaUser');
const aresUserConstants = require('constants/aresUser');
const {
    MYPROFILE_BROKER_STOCKS_URL,
    MYPROFILE_BROKER_ETFS_URL,
    MYPROFILE_BROKER_WARRANTS_URL,
    MYPROFILE_BROKER_FUNDS_URL,
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_INSURANCES_URL,
} = require('constants/index');
const {
    BROKERAGE,
    CREDIT,
    DEPOSITS_TOPBAR,
    INSURANCES,
    LOANS_MORTGAGES,
    TPPS_ENABLED,
    TYPE_STOCKS,
    TYPE_PLANS,
    TYPE_WARRANTS,
    TYPE_FUNDS,
    TYPE_ETFS,
    TAXATION,
    MARKETS_AND_NEWS
} = require('constants/flagBasedFeatures');
const {
    ES, ES_LANG,
    EN, EN_LANG,
    NL, NL_LANG,
    PT, PT_LANG,
    DE, DE_LANG,
    languageCorrelation,
} = require('constants/contactCenter/language');
const {
    MENU_DISASTER_WHITELIST
} = require('constants/secureRouting');


const getTabs = (flagBasedFeatures, immGlobalPosition) => immGlobalPosition.get("isClientWithoutAccounts") ? 
[
    {
        label: <FormattedText value="navbar-accounts" />,
        icon: 'my-money',
        path: '/myprofile/accounts',
        idSuffix: 'SideBarMyAccounts'
    },
    {
        label: <FormattedText value="navBarDisaster-operative" />,
        icon: 'Operative',
        idSuffix: 'SideBarOperative',
        dropdown: [
            ...(flagBasedFeatures.get(LOANS_MORTGAGES) ?
                [{
                    label: <FormattedText value="navbar-loans" />,
                    path: '/myprofile/loans-mortgages',
                }] : []),
            ...(flagBasedFeatures.get(CREDIT)
            && (!!immGlobalPosition
            && immGlobalPosition.getIn(['savings','allSavings'])
            && immGlobalPosition.getIn(['savings','allSavings']).size) || flagBasedFeatures.get(DEPOSITS_TOPBAR) ?
                [{
                    label: <FormattedText value="navbar-deposits" />,
                    path: '/myprofile/deposits',
                }] : []),
                ...(flagBasedFeatures.get(INSURANCES) ?
                [{
                    label: <FormattedText value="navbar-insurances" />,
                    path: MYPROFILE_INSURANCES_URL,
                }] : []),
        ]
    },
    {
        label: <FormattedText value="navBarDisaster-settings" />,
        icon: 'Settings',
        idSuffix: 'SideBarSettings',
        dropdown: [
            {
                label: <FormattedText value="profileNavBar-personalData" />,
                path: '/myprofile/edit',
            },
            ...(flagBasedFeatures.get(TPPS_ENABLED) ?
                [{
                    label: <FormattedText value="profileNavBar-tpps" />,
                    path: '/myprofile/keys/tpps',
                }] : []
            ),
            {
                label: <FormattedText value="profileNavBar-security" />,
                path: '/myprofile/keys/securitykit'
            },
            {
                label: <FormattedText value="profileNavBar-devices" />,
                path: '/myprofile/devices'
            },
            {
                label: <FormattedText value="profileNavBar-documentation" />,
                path: '/myprofile/documentation',
            },
            ...(flagBasedFeatures.get(TAXATION) ?
                    [{
                        label: <FormattedText value="profileNavBar-taxAndRents"/>,
                        path: '/myprofile/taxAndRents',
                    }] : []
            ),
            {
                label: <FormattedText value="profileNavBar-promotions" />,
                path: '/myprofile/promotions/hirePromotion'
            },
            {
                label: <FormattedText value="profileNavBar-sendSignatureKey" />,
                path: '/keys/send-n2-post'
            }
        ]
    }
] : [
    {
        label: <FormattedText value="navbar-today" />,
        icon: 'global',
        path: '/myprofile/global',
        idSuffix: 'SideBarGlobalPosition'

    },
    {
        label: <FormattedText value="navbar-cards" />,
        icon: 'my-cards',
        path: '/myprofile/cards',
        idSuffix: 'SideBarMyCards'
    },
    {
        label: <FormattedText value="navbar-accounts" />,
        icon: 'my-money',
        path: '/myprofile/accounts',
        idSuffix: 'SideBarMyAccounts'
    },
    {
        label: <FormattedText value="navbar-transfers" />,
        icon: 'my-transfers',
        path: '/myprofile/transfers',
        idSuffix: 'SideBarMyTransfers'
    },
        {
            label: <FormattedText value="navBarDisaster-operative" />,
            icon: 'Operative',
            idSuffix: 'SideBarOperative',
            dropdown: [
                ...(flagBasedFeatures.get(LOANS_MORTGAGES) ?
                    [{
                        label: <FormattedText value="navbar-loans" />,
                        path: '/myprofile/loans-mortgages',
                    }] : []),
                ...(flagBasedFeatures.get(CREDIT)
                && (!!immGlobalPosition
                && immGlobalPosition.getIn(['savings','allSavings'])
                && immGlobalPosition.getIn(['savings','allSavings']).size) || flagBasedFeatures.get(DEPOSITS_TOPBAR) ?
                    [{
                        label: <FormattedText value="navbar-deposits" />,
                        path: '/myprofile/deposits',
                    }] : []),
                 ...(flagBasedFeatures.get(INSURANCES) ?
                    [{
                        label: <FormattedText value="navbar-insurances" />,
                        path: MYPROFILE_INSURANCES_URL,
                    }] : []),
            ]
        },
    {
        label: <FormattedText value="navbar-investments" />,
        icon: 'investments',
        idSuffix: 'SideBarInvestments',
        dropdown: [
            {
                label: <FormattedText value="navbarInvestments-myInvestments" />,
                path: '/myprofile/broker',
            },
            {

                label:  <FormattedText value="navbarInvestments-weInvestForYou" />,
                path: '',
                subitems: [
                    {
                        label: <FormattedText value="navbarInvestments-automatedInvestment" />,
                        path: '/myprofile/broker/general/robo',
                    },
                    {
                        label: <FormattedText value="navbarInvestments-InvestmentByObjectives" />,
                        path: '/myprofile/broker/general/robo',
                    }
                ],
            },

            ...(flagBasedFeatures.get(TYPE_STOCKS) ||
            flagBasedFeatures.get(TYPE_FUNDS) ||
            flagBasedFeatures.get(TYPE_PLANS) ||
            flagBasedFeatures.get(TYPE_ETFS) ||
            flagBasedFeatures.get(TYPE_WARRANTS) ?
            {
                label: <FormattedText value="navbarInvestments-products" />,
                path: '',
                subitems: [
                    ...(flagBasedFeatures.get(TYPE_STOCKS) ?
                    [{
                        label: <FormattedText value="navbarInvestments-actions" />,
                        path: MYPROFILE_BROKER_STOCKS_URL
                    }] : []),
                    ...(flagBasedFeatures.get(TYPE_FUNDS) ?
                    [{
                        label: <FormattedText value="navbarInvestments-funds" />,
                        path: MYPROFILE_BROKER_FUNDS_URL
                    }] : []),
                    ...(flagBasedFeatures.get(TYPE_PLANS) ?
                    [{
                        label: <FormattedText value="navbarInvestments-plans" />,
                        path: MYPROFILE_BROKER_PLANS_URL
                    }] : []),
                    ...(flagBasedFeatures.get(TYPE_ETFS) ?
                    [{
                        label: <FormattedText value="navbarInvestments-etfs" />,
                        path: MYPROFILE_BROKER_ETFS_URL
                    }] : []),
                    ...(flagBasedFeatures.get(TYPE_WARRANTS) ?
                    [{
                        label: <FormattedText value="navbarInvestments-warrants" />,
                        path: MYPROFILE_BROKER_WARRANTS_URL
                    }] : []),
                ]
            }: []),
            ...(flagBasedFeatures.get(BROKERAGE) ?
            [{
                label: <FormattedText value="navbarInvestments-hireStocksContract" />,
                path: '/myprofile/broker/stocksContract',
            }] : []),
            ...(flagBasedFeatures.get(BROKERAGE) ?
            [{
                label: <FormattedText value="navbarInvestments-corporatesOperations" />,
                path: '/myprofile/broker/corporatesOperations',
            }] : []),
            {
                label: <FormattedText value="navbarInvestments-ordersAndMovements" />,
                path: '/myprofile/broker/ordersAndMovements',
            },
            ...(flagBasedFeatures.get(MARKETS_AND_NEWS) ?
            [{
                label: <FormattedText value="navbarInvestments-marketNews" />,
                path: '/myprofile/broker/markets',
            }] : []),
        ]
    },
    {
        label: <FormattedText value="navBarDisaster-settings" />,
        icon: 'Settings',
        idSuffix: 'SideBarSettings',
        dropdown: [
            {
                label: <FormattedText value="profileNavBar-personalData" />,
                path: '/myprofile/edit',
            },
            ...(flagBasedFeatures.get(TPPS_ENABLED) ?
                [{
                    label: <FormattedText value="profileNavBar-tpps" />,
                    path: '/myprofile/keys/tpps',
                }] : []
            ),
            {
                label: <FormattedText value="profileNavBar-security" />,
                path: '/myprofile/keys/securitykit'
            },
            {
                label: <FormattedText value="profileNavBar-devices" />,
                path: '/myprofile/devices'
            },
            {
                label: <FormattedText value="profileNavBar-documentation" />,
                path: '/myprofile/documentation',
            },
            ...(flagBasedFeatures.get(TAXATION) ?
                    [{
                        label: <FormattedText value="profileNavBar-taxAndRents"/>,
                        path: '/myprofile/taxAndRents',
                    }] : []
            ),
            {
                label: <FormattedText value="profileNavBar-promotions" />,
                path: '/myprofile/promotions/hirePromotion'
            },
            {
                label: <FormattedText value="profileNavBar-sendSignatureKey" />,
                path: '/keys/send-n2-post'
            }
        ]
    }
];

const getTabLanguage = () => {
    return [
        {
            label: languageCorrelation[getLanguage()],
            isLanguageTab: true,
            icon: 'Operative',
            idSuffix: 'SideBarLanguage',
            customClassName: 'navbar-language__navbar-item',
            dropdown: [
                {
                    label: ES,
                    hreflang: ES_LANG
                },
                {
                    label: EN,
                    hreflang: EN_LANG
                },
                {
                    label: NL,
                    hreflang: NL_LANG
                },
                {
                    label: PT,
                    hreflang: PT_LANG
                },
                {
                    label: DE,
                    hreflang: DE_LANG
                },
            ]
        }
    ]
};



class NavbarCC extends React.Component {

    constructor(props) {
        super(props);
    }

    handleOnClickItem = ({ hreflang }) => {
        storage.cookies.set('language', hreflang);
        if (storage.cookies.get('language') === hreflang)
            location.reload();
    };

    isNotAllowedPathToShowTabLanguage = () => [
        '/gap-access',
        '/keys/login-as-client'
    ].includes(window.location.pathname);

    getTabsItems = () => {

        const tabLanguage = !this.isNotAllowedPathToShowTabLanguage() && getTabLanguage();
        const {
            flagBasedFeatures,
            getTabs,
            immGlobalPosition,
            immProfileFields,
        } = this.props;
        const nerudaUserTabs = [
            'my-cards',
            'my-money',
            'Settings',
        ];
        const isNerudaUser = immProfileFields.get('isNerudaUser');
        let newTabs = getTabs(flagBasedFeatures, immGlobalPosition).concat(tabLanguage);

        if (isNerudaUser){
            newTabs = newTabs.filter((tab)=> nerudaUserTabs.includes(tab.icon) || tab.isLanguageTab);
        }

        const aresUserTabs = [
            'Operative',
            'my-money',
            'Settings',
        ];
        const isAresUser = immProfileFields.get('isAresUser');
        if (isAresUser) {
            newTabs = newTabs.filter((tab)=> aresUserTabs.includes(tab.icon) || tab.isLanguageTab);
        }

        return newTabs.map((tabContent, index) => {

            const customClassName =
                tabContent.customClassName ?
                tabContent.customClassName :
                'navbar-disaster__navbar-item';

            if (tabContent.dropdown) {

                if (isNerudaUser && tabContent.icon === 'Settings'){
                    tabContent.dropdown = tabContent.dropdown.filter((tabItem) => nerudaUserConstants.allowedSettingsDropdownCC.includes(tabItem.path));
                }

                if (isAresUser && tabContent.icon === 'Settings'){
                    tabContent.dropdown = tabContent.dropdown.filter((tabItem) => aresUserConstants.allowedSettingsDropdownCC.includes(tabItem.path));
                }

                if (isAresUser && tabContent.icon === 'Operative'){
                    tabContent.dropdown = tabContent.dropdown.filter((tabItem) => aresUserConstants.allowedURLs.includes(tabItem.path));
                }

                return (
                    <TabDropdown
                        key={`tab-key-${index}`}
                        label={tabContent.label}
                        locator={tabContent.idSuffix}
                        dropdown={tabContent.dropdown}
                        path={tabContent.path}
                        onClickItem={tabContent.isLanguageTab && this.handleOnClickItem}
                        isSelected={true}
                        customClassName={customClassName}
                    />
                );

            }

            return (
                <TabLink
                    key={`tab-key-${index}`}
                    label={tabContent.label}
                    locator={tabContent.idSuffix}
                    link={tabContent.path}
                    customClassName={customClassName}
                />
            );
        });
    }

    render() {
        const {
            immProfileFields ,
            url,
            changeOfficeValidation,
            immAgentLogin,
            immGlobalPosition
        } = this.props;

        if (!__CONTACT_CENTER__) return null;
        if (MENU_DISASTER_WHITELIST.includes(url)) return null;
        const hasBeenFetched = immGlobalPosition.get("hasBeenFetched");
        const SecurityLevel = getSecurityLevel();
        const tabsEl = this.getTabsItems();
        const name = getFullName(immProfileFields, false);
        const allowMenu = SecurityLevel === securityLevels.N1 || SecurityLevel === securityLevels.N2

        const showTopBar = isDisasterRecoveryMode();
        const topBar = showTopBar && <TopBarCC
            immAgentLogin={immAgentLogin}
            changeOfficeValidation={changeOfficeValidation}
            securityLevel={SecurityLevel}
            allowMenu={allowMenu}
            onExit={() => { window.console.log('exit') }}
        />

        const showBottomBar = allowMenu && isDisasterRecoveryMode();
        const bottomBar = showBottomBar && <BottomBarCC clientName={name} />

        const showTabMenu = allowMenu && hasBeenFetched;
        const tabsMenu = showTabMenu && <Tabs customClassName={this.props.customClassName} linkTabSelected={url}  >
            {tabsEl}
        </Tabs>

        return (
            <div className="container-navbarcc">
                {topBar}
                {bottomBar}
                {tabsMenu}
            </div>
        );
    }
}

NavbarCC.defaultProps = {
    customClassName: 'navbar-disaster__navbar',
    // tabs: [],
    tabLanguage: [],
    getTabs: getTabs
}

NavbarCC.propTypes = {
    url:  PropTypes.string,
    immProfileFields: PropTypes.object,
    linkTabSelected: PropTypes.string,
    customClassName: PropTypes.string,
    changeOfficeValidation: PropTypes.func.isRequired,
    immAgentLogin: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    // tabs: PropTypes.arrayOf(PropTypes.shape({
    //     label: PropTypes.string.isRequired,
    //     path: PropTypes.string,
    //     dropdown: PropTypes.arrayOf(PropTypes.shape({
    //         label: PropTypes.string.isRequired,
    //         path: PropTypes.string.isRequired,
    //         subitems: PropTypes.arrayOf(PropTypes.shape({
    //             label: PropTypes.string.isRequired,
    //             path: PropTypes.string.isRequired
    //         }))
    //     }))
    // })),
    flagBasedFeatures: PropTypes.shape({}),
    getTabs: PropTypes.func.isRequired,
    tabLanguage: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        idSuffix: PropTypes.string.isRequired,
        customClassName: PropTypes.string.isRequired,
        dropdown: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            hreflang: PropTypes.string.isRequired
        }))
    }))
};

const connectedView = connect(state => ({
    immGlobalPosition: state.globalPosition,
    immProfileFields: state.profile,
    flagBasedFeatures: state.flagBasedFeatures,
    immAgentLogin: state.agentAuthentication
}), {
    changeOfficeValidation: agentAuthentication.agentOfficeValidation
})(NavbarCC);
module.exports = connectedView;
